import React from 'react';
import styles from "../../../styles/ai/education/AIEducation.module.css";

import AIEducationSection from '../../../components/ai/education/AIEducationSection';

const AIEducation = () => {
  return (
    <>
      <AIEducationSection styles={styles} />
    </>
  )
}

export default AIEducation